import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import sv from 'date-fns/locale/sv';
import no from 'date-fns/locale/nb';
import en from 'date-fns/locale/en-US';
import da from "date-fns/locale/da";
import uk from "date-fns/locale/uk";
import Moment from "moment";
import { connect } from "react-redux";
import { TimePicker } from "UI/Inputs";
import { translate, getActiveLanguage } from "@haldor/ui";
var DatePickerFromTo = /*#__PURE__*/function (_Component) {
  function DatePickerFromTo(props) {
    var _this;
    _classCallCheck(this, DatePickerFromTo);
    _this = _callSuper(this, DatePickerFromTo, [props]);
    _defineProperty(_this, "getDateFormat", function () {
      var format = Moment.localeData(getActiveLanguage()).longDateFormat("L");
      var newFormat = format.replace("YYYY", "yyyy");
      var days = newFormat.replace("DD", "dd");
      return days;
    });
    _defineProperty(_this, "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.values != null) {
        if (nextProps.type == "assignment") {
          if (nextProps.values == null) {
            return;
          }
          _this.setState({
            timeStart: nextProps.values.startDate != null ? Moment.utc(nextProps.values.startDate).local() : Moment(),
            timeEnd: nextProps.values.dueDate != null ? Moment.utc(nextProps.values.dueDate).local() : Moment().add(7, "days"),
            dtPickerStartDate: nextProps.values.startDate != null ? Moment.utc(nextProps.values.startDate).local() : Moment(),
            dtPickerDueDate: nextProps.values.dueDate != null ? Moment.utc(nextProps.values.dueDate).local() : Moment().add(7, "days"),
            updated: true
          });
        } else if (nextProps.type == "plan") {
          if (nextProps.values == null) {
            return;
          }
          _this.setState({
            timeStart: nextProps.values.timeStart != null ? Moment.utc(nextProps.values.timeStart).local() : Moment(),
            timeEnd: nextProps.values.timeEnd != null ? Moment.utc(nextProps.values.timeEnd).local() : Moment().add(7, "days"),
            dtPickerStartDate: nextProps.values.timeStart != null ? Moment.utc(nextProps.values.timeStart).local() : Moment(),
            dtPickerDueDate: nextProps.values.timeEnd != null ? Moment.utc(nextProps.values.timeEnd).local() : Moment().add(7, "days"),
            updated: true
          });
        }
      }
    });
    _defineProperty(_this, "componentDidMount", function () {
      _this.onChange();
    });
    _defineProperty(_this, "onStartChange", function (date) {
      var newDate = Moment(date);
      var _this$state = _this.state,
        dtPickerStartDate = _this$state.dtPickerStartDate,
        timeStart = _this$state.timeStart,
        dtPickerDueDate = _this$state.dtPickerDueDate,
        timeEnd = _this$state.timeEnd;
      dtPickerStartDate = newDate;
      timeStart = newDate;
      if (newDate.diff(dtPickerDueDate) > 0) {
        dtPickerDueDate = newDate;
        timeEnd = newDate;
      }
      _this.setState({
        dtPickerDueDate: dtPickerDueDate,
        timeEnd: timeEnd,
        dtPickerStartDate: dtPickerStartDate,
        timeStart: timeStart
      }, function () {
        _this.onChange();
      });
    });
    _defineProperty(_this, "onEndChange", function (date) {
      var newDate = Moment(date);
      var _this$state2 = _this.state,
        dtPickerDueDate = _this$state2.dtPickerDueDate,
        timeEnd = _this$state2.timeEnd;
      dtPickerDueDate = newDate;
      timeEnd = newDate;
      _this.setState({
        dtPickerDueDate: dtPickerDueDate,
        timeEnd: timeEnd
      }, function () {
        _this.onChange();
      });
    });
    _defineProperty(_this, "onStartTimeChange", function (time) {
      var _this$state3 = _this.state,
        dtPickerStartDate = _this$state3.dtPickerStartDate,
        timeStart = _this$state3.timeStart;
      dtPickerStartDate = Moment(time);
      timeStart = Moment(time);
      _this.setState({
        dtPickerStartDate: dtPickerStartDate,
        timeStart: timeStart
      }, function () {
        _this.onChange();
      });
    });
    _defineProperty(_this, "onEndTimeChange", function (time) {
      var _this$state4 = _this.state,
        dtPickerDueDate = _this$state4.dtPickerDueDate,
        timeEnd = _this$state4.timeEnd;
      dtPickerDueDate = Moment(time);
      timeEnd = Moment(time);
      _this.setState({
        dtPickerDueDate: dtPickerDueDate,
        timeEnd: timeEnd
      }, function () {
        _this.onChange();
      });
    });
    _defineProperty(_this, "onChange", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var dates;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(_this.props.minDate != null)) {
              _context.next = 7;
              break;
            }
            if (!_this.state.timeStart.isSameOrAfter(_this.props.minDate, "day")) {
              _context.next = 2;
              break;
            }
            if (!_this.state.startInvalid) {
              _context.next = 1;
              break;
            }
            _context.next = 1;
            return _this.setState({
              startInvalid: false
            });
          case 1:
            _context.next = 3;
            break;
          case 2:
            _context.next = 3;
            return _this.setState({
              startInvalid: true
            });
          case 3:
            if (!_this.state.timeEnd.isSameOrAfter(_this.props.minDate, "day")) {
              _context.next = 5;
              break;
            }
            if (!_this.state.endInvalid) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return _this.setState({
              endInvalid: false
            });
          case 4:
            _context.next = 6;
            break;
          case 5:
            _context.next = 6;
            return _this.setState({
              endInvalid: true
            });
          case 6:
            _this.onDateValidChange();
          case 7:
            if (_this.props.onChange) {
              dates = {
                start: _this.state.timeStart,
                end: _this.state.timeEnd
              };
              _this.props.onChange(dates);
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "onStartDateInput", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
        var date;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(event == null)) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return", false);
            case 1:
              date = Moment(event.target.value);
              if (date.isValid()) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", false);
            case 2:
              if (!(_this.props.minDate != null)) {
                _context2.next = 7;
                break;
              }
              if (!date.isSameOrAfter(_this.props.minDate, "day")) {
                _context2.next = 5;
                break;
              }
              if (!_this.state.startInvalid) {
                _context2.next = 4;
                break;
              }
              _context2.next = 3;
              return _this.setState({
                startInvalid: false
              });
            case 3:
              _this.onDateValidChange();
            case 4:
              _context2.next = 7;
              break;
            case 5:
              _context2.next = 6;
              return _this.setState({
                startInvalid: true
              });
            case 6:
              _this.onDateValidChange();
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onEndDateInput", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
        var date;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(event == null)) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return", false);
            case 1:
              date = Moment(event.target.value);
              if (date.isValid()) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", false);
            case 2:
              if (!(_this.props.minDate != null)) {
                _context3.next = 7;
                break;
              }
              if (!date.isSameOrAfter(_this.props.minDate, "day")) {
                _context3.next = 5;
                break;
              }
              if (!_this.state.endInvalid) {
                _context3.next = 4;
                break;
              }
              _context3.next = 3;
              return _this.setState({
                endInvalid: false
              });
            case 3:
              _this.onDateValidChange();
            case 4:
              _context3.next = 7;
              break;
            case 5:
              _context3.next = 6;
              return _this.setState({
                endInvalid: true
              });
            case 6:
              _this.onDateValidChange();
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onDateValidChange", function () {
      if (_this.props.onValidate != null && typeof _this.props.onValidate == "function") {
        _this.props.onValidate(!_this.state.startInvalid && !_this.state.endInvalid);
      }
    });
    Moment.locale(getActiveLanguage());
    registerLocale('en-US', en);
    registerLocale('sv-SE', sv);
    registerLocale('nb-NO', no);
    registerLocale('da-DK', da);
    registerLocale('uk', uk);
    setDefaultLocale('en-US');
    if (props.values != null && props.type == "assignment") {
      _this.state = {
        timeStart: props.values.startDate != null ? Moment.utc(props.values.startDate).local() : Moment(),
        timeEnd: props.values.dueDate != null ? Moment.utc(props.values.dueDate).local() : Moment().add(7, "days"),
        dtPickerStartDate: props.values.startDate != null ? Moment.utc(props.values.startDate).local() : Moment(),
        dtPickerDueDate: props.values.dueDate != null ? Moment.utc(props.values.dueDate).local() : Moment().add(7, "days"),
        updated: false
      };
    } else if (props.values != null && props.type == "plan") {
      _this.state = {
        timeStart: props.values.timeStart != null ? Moment.utc(props.values.timeStart).local() : Moment(),
        timeEnd: props.values.timeEnd != null ? Moment.utc(props.values.timeEnd).local() : Moment().add(7, "days"),
        dtPickerStartDate: props.values.timeStart != null ? Moment.utc(props.values.timeStart).local() : Moment(),
        dtPickerDueDate: props.values.timeEnd != null ? Moment.utc(props.values.timeEnd).local() : Moment().add(7, "days"),
        updated: false,
        startInvalid: false,
        endInvalid: false
      };
    } else if (props.values != null && props.values.start != null && props.values.end != null) {
      _this.state = {
        timeStart: props.values.start != null ? Moment.utc(props.values.start).local() : Moment(),
        timeEnd: props.values.end != null ? Moment.utc(props.values.end).local() : Moment().add(7, "days"),
        dtPickerStartDate: props.values.start != null ? Moment.utc(props.values.start).local() : Moment(),
        dtPickerDueDate: props.values.end != null ? Moment.utc(props.values.end).local() : Moment().add(7, "days"),
        updated: false
      };
    } else {
      _this.state = {
        timeStart: Moment(),
        timeEnd: Moment().add(7, "days"),
        dtPickerStartDate: Moment(),
        dtPickerDueDate: Moment().add(7, "days"),
        updated: false
      };
    }
    return _this;
  }
  _inherits(DatePickerFromTo, _Component);
  return _createClass(DatePickerFromTo, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, this.props.timePicker ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-start"
      }, this.props.translate("Start")), /*#__PURE__*/React.createElement(DatePicker, {
        selected: this.state.dtPickerStartDate.toDate(),
        startDate: this.state.dtPickerStartDate.toDate(),
        endDate: this.state.dtPickerDueDate.toDate(),
        minDate: this.props.minDate != null ? Moment(this.props.minDate).toDate() : null,
        dateFormat: this.getDateFormat(),
        onChange: this.onStartChange,
        popperModifiers: {
          preventOverflow: {
            enabled: false
          },
          positionFixed: true
        },
        selectsStart: true,
        popperPlacement: "bottom-start",
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: "",
        disabled: this.props.disabled,
        onBlur: this.onStartDateInput,
        locale: getActiveLanguage()
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last static"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: ""
      }, this.props.translate("Start time")), /*#__PURE__*/React.createElement(TimePicker, {
        placeholder: "V\xE4lj starttid",
        time: this.state.dtPickerStartDate,
        onChange: this.onStartTimeChange,
        disabled: this.props.disabled
      }))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-start"
      }, this.props.translate("Start")), /*#__PURE__*/React.createElement(DatePicker, {
        selected: this.state.dtPickerStartDate.toDate(),
        startDate: this.state.dtPickerStartDate.toDate(),
        endDate: this.state.dtPickerDueDate.toDate(),
        dateFormat: this.getDateFormat(),
        minDate: this.props.minDate != null ? Moment(this.props.minDate).toDate() : null,
        onChange: this.onStartChange,
        popperModifiers: {
          preventOverflow: {
            enabled: false
          },
          positionFixed: true
        },
        popperPlacement: "bottom-start",
        selectsStart: true,
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: "",
        disabled: this.props.disabled,
        onBlur: this.onStartDateInput,
        locale: getActiveLanguage()
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, this.props.timePicker ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-end"
      }, this.props.translate("End")), /*#__PURE__*/React.createElement(DatePicker, {
        selected: this.state.dtPickerDueDate.toDate(),
        startDate: this.state.dtPickerStartDate.toDate(),
        endDate: this.state.dtPickerDueDate.toDate(),
        minDate: this.state.dtPickerStartDate.toDate(),
        onChange: this.onEndChange,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: true
        },
        popperPlacement: "bottom-end",
        selectsEnd: true,
        dateFormat: this.getDateFormat(),
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: "",
        disabled: this.props.disabled,
        onBlur: this.onEndDateInput,
        onChangeRaw: this.onEndDateInput,
        locale: getActiveLanguage()
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last static"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: ""
      }, this.props.translate("End time")), /*#__PURE__*/React.createElement(TimePicker, {
        placeholder: "V\xE4lj slutdatum",
        time: this.state.dtPickerDueDate,
        onChange: this.onEndTimeChange,
        disabled: this.props.disabled
      }))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-end"
      }, this.props.translate("End")), /*#__PURE__*/React.createElement(DatePicker, {
        selected: this.state.dtPickerDueDate.toDate(),
        startDate: this.state.dtPickerStartDate.toDate(),
        endDate: this.state.dtPickerDueDate.toDate(),
        minDate: this.state.dtPickerStartDate.toDate(),
        onChange: this.onEndChange,
        popperPlacement: "bottom-end",
        dateFormat: this.getDateFormat(),
        positionFixed: true,
        popperModifiers: {
          preventOverflow: {
            enabled: false
          }
        },
        selectsEnd: true,
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: "",
        disabled: this.props.disabled,
        onBlur: this.onEndDateInput,
        onChangeRaw: this.onEndDateInput,
        locale: getActiveLanguage()
      }))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps)(DatePickerFromTo);